import { zodResolver } from "@hookform/resolvers/zod";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link, useNavigate } from "react-router-dom";
import { z } from "zod";
import { auth, sendPasswordReset } from "../firebase";

const resetSchema = z.object({
	email: z.string().email("Enter a valid email address"),
});

type ResetFormValues = z.infer<typeof resetSchema>;

function Reset() {
	const [user, loading] = useAuthState(auth);
	const [feedback, setFeedback] = useState<string | null>(null);
	const navigate = useNavigate();

	const {
		register,
		handleSubmit,
		formState: { errors, isSubmitting },
		reset,
		watch,
	} = useForm<ResetFormValues>({
		resolver: zodResolver(resetSchema),
		mode: "onChange",
	});
	const emailValue = watch("email", "");

	useEffect(() => {
		if (!loading && user) {
			navigate("/dashboard");
		}
	}, [loading, navigate, user]);

	const onSubmit = async ({ email }: ResetFormValues) => {
		setFeedback(null);
		try {
			await sendPasswordReset(email);
			setFeedback("Te enviamos un enlace para restablecer tu contraseña.");
			reset();
		} catch (error) {
			if (error instanceof Error) {
				setFeedback(error.message);
			} else {
				setFeedback("Unable to send reset email. Please try again.");
			}
		}
	};

	return (
		<section className="page page--auth">
			<div className="auth-card">
				<header>
					<p className="eyebrow">Recupera el acceso</p>
					<h1>Restablecer contraseña</h1>
					<p>Enviaremos un enlace seguro a tu correo registrado.</p>
				</header>
				<form className="auth-form" onSubmit={handleSubmit(onSubmit)} noValidate>
					<label htmlFor="reset-email">Correo electrónico</label>
					<input
						id="reset-email"
						type="email"
						className={clsx("auth-input", {
							"has-value": Boolean(emailValue),
							"input-error": Boolean(errors.email),
						})}
						placeholder="correo@empresa.com"
						autoComplete="email"
						{...register("email")}
					/>
					{errors.email && (
						<span className="form-error" role="alert">
							{errors.email.message}
						</span>
					)}

					<button
						className="button button--primary button--full"
						type="submit"
						disabled={isSubmitting || loading}
					>
						Enviar enlace
					</button>
					{feedback && <p className="form-feedback">{feedback}</p>}

					<div className="auth-form__links">
						<Link to="/login">Recordé mi contraseña</Link>
						<Link to="/register">Crear cuenta</Link>
					</div>
				</form>
			</div>
		</section>
	);
}
export default Reset;
